import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

/**
 * Limited Edition Prints — Coming Soon placeholder.
 * Replaces the live Release grid while editions, pricing and titles are
 * being finalised. Keeps the same dramatic spacing & typography so the
 * page rhythm of /chapter-ii is preserved.
 */
const ReleaseComingSoon = () => {
  return (
    <section
      id="release"
      data-testid="release-coming-soon"
      className="bone-section relative"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 pt-32 md:pt-48 pb-32 md:pb-48">
        <Reveal className="max-w-3xl">
          <p className="hairline mb-6" data-testid="release-soon-label">
            III. The Release
          </p>
          <h2 className="font-serif italic text-5xl md:text-7xl leading-[1.0]">
            Limited edition prints.
          </h2>
          <p className="font-serif italic text-2xl md:text-3xl mt-10 opacity-80 leading-[1.3]">
            A small, signed and numbered release from Chapter 2 — prepared
            with care, ready soon.
          </p>
        </Reveal>

        <Reveal delay={180} className="mt-20 md:mt-28">
          <div className="rule opacity-30" />
          <div
            className="py-16 md:py-24 text-center"
            data-testid="release-soon-statement"
          >
            <p className="font-serif italic text-6xl md:text-8xl leading-none">
              Coming soon.
            </p>
          </div>
          <div className="rule opacity-30" />
        </Reveal>

        <Reveal delay={260} className="mt-16 md:mt-20 flex flex-col md:flex-row gap-6 md:gap-12 md:items-baseline md:justify-between">
          <p className="font-serif italic text-xl md:text-2xl opacity-75 max-w-md leading-relaxed">
            Join the newsletter to be among the first to receive the release
            when it opens.
          </p>
          <Link
            to="/contact?topic=acquisition"
            className="link-quiet font-serif italic text-xl md:text-2xl"
            data-testid="release-soon-register"
          >
            Register your interest →
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default ReleaseComingSoon;
